"use strict";

var $ = require('jquery');
var data = require('./data');

var root = require('./root').window;
var hudlAnalytics = {};
var preloadQueue = [];
var processPreloadQueue = function() {
  while (preloadQueue.length) {
    var queuedItem = preloadQueue.shift();
    hudlAnalytics[queuedItem.method].apply(null, queuedItem.args);
  }
};

[
    { name: 'trackSubmit' },
    { name: 'trackClick' },
    { name: 'trackLink' },
    { name: 'trackForm' },
    { name: 'pageview' },
    { name: 'identify', optionsIndex: 2 },
    { name: 'group', optionsIndex: 2 },
    { name: 'track', optionsIndex: 2 },
    { name: 'ready' },
    { name: 'alias' },
    { name: 'page', optionsIndex: 3 },
    { name: 'once' },
    { name: 'off' },
    { name: 'on' }
].forEach(function (methodObj) {
  hudlAnalytics[methodObj.name] = function () {
    var args = Array.prototype.slice.call(arguments);
    if (typeof Intercom !== 'undefined') {
      if (methodObj.name === 'track') {
        args.unshift('trackEvent');
      } else {
        console.error('That method is not currently supported in analytics.js - please add support if necessary. Method=%s', methodObj.name);
        return;
      }
      Intercom.apply(Intercom, args);
    } else {
      preloadQueue.push({
        method: methodObj.name,
        args: args
      });
    }
  };
});

// This exists for the Silverlight-based Presentation Editor to log data to.
// This was not duplicated to hudl.analytics in ~/js.
hudlAnalytics.trackWithJsonStr = function (eventName, dataStr) {
  var data = {};
  // Sometimes we need to be able to send this an arg of a json string,
  // rather than an object. At least until Silverlight is completely dead.
  if (dataStr && (typeof dataStr === 'string' || dataStr instanceof String)) {
    try {
      data = JSON && JSON.parse(dataStr) || dataStr;
    } catch (e) {
      if (debug) {
        debugLog('trackWithJsonStr() Unable to parse data string, dataStr=%s err=%o', datastr, e);
      }
    }
  }

  return this.track(eventName, data);
};

// only used by our tests
hudlAnalytics.unload = function() {
  root._hudlAnalyticsInvoked = false;
};

hudlAnalytics.init = function(customValues) {
  var additionalValues = customValues || {};
  var analyticsIdentifyData = data.getNullable('analyticsIdentifyData') || {};
  var analyticsIntegrations = data.getNullable('analyticsIntegrations') || [];
  var intercomSettings = analyticsIntegrations.reduce(function(prev, curr) {
    return curr.name === 'Intercom' && curr.enabled ? curr.config : prev;
  }, {});

  if (intercomSettings) {
    window.intercomSettings = $.extend({}, analyticsIdentifyData, intercomSettings, additionalValues, {
      user_id: analyticsIdentifyData.userId,
      created_at: analyticsIdentifyData.createdAt,
    });

    // This is copied from the intercom documentation and slightly
    // modified to call a method once the script has been loaded
    if (typeof window.Intercom === 'function') {
      window.Intercom('reattach_activator');
      window.Intercom('update', intercomSettings);
    } else {
      window.Intercom = function() { window.Intercom.c(arguments); };
      window.Intercom.q = [];
      window.Intercom.c = function(args) { window.Intercom.q.push(args); };
      $('<script async="true" src="https://widget.intercom.io/widget/lsy960pt" type="text/javascript"></script>')
        .prependTo($(document.head))
        .ready(processPreloadQueue);
    }
  }

  root._hudlAnalyticsInvoked = true;
};

module.exports = hudlAnalytics;
